import product1 from "./assets/products/1.webp";
import product2 from "./assets/products/2.jpg";
import product3 from "./assets/products/3.jpg";
import product4 from "./assets/products/4.jpg";
import product5 from "./assets/products/5.jpg";
import product6 from "./assets/products/6.jpg";
import product7 from "./assets/products/7.jpg";
import product8 from "./assets/products/8.jpg";
import product9 from "./assets/products/9.webp";

export const GPRODUCTS = [
  {
    id: 1,
    productName: "Teen Girl Drop Shoulder Hooded Sweatshirt Dress",
    price: 449,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Girls' (big Kids') Red Dress With Asymmetrical Hem And Ruffled Details",
    price: 349,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Kids Top-Stitching Drop Shoulder Pocket Patched Tee",
    price: 899,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Toddler Girls Two Tone Plaid Flap Pocket Drop Shoulder Blouse",
    price: 699,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Kids EVRYDAY Girls' Loose Fit Sweater With Hearts Design Round Neckline And Wide Leg Pants Set",
    price: 819,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Kids Cooltwn Tween Girl Letter Graphic Drop Shoulder Pullover & Sweatpants",
    price: 979,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Tween Girl Bear & Letter Graphic Drop Shoulder Hoodie & Leggings",
    price: 449,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Young Girl 1pc Rabbit Design Hooded Flannel Sleep Jumpsuit",
    price: 399,
    productImage: product8,
  },
  {
    id: 9,
    productName: "Young Girl Ditsy Floral Print PJ Set",
    price: 1399,
    productImage: product9,
  },
];
